module.exports = __webpack_public_path__ + "img/lab.1c9a85ac.svg";